/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {Icon, Text} from '@ui-kitten/components';
import React from 'react';
import {useIsFocused} from '@react-navigation/native';
import {Linking, StyleSheet, TouchableOpacity} from 'react-native';
import {getDownloadTimeTable, getMyTimetable} from '../../../apis';
import {px, useAsync, useAsyncFn, useIsLandscape} from '../../../utils';
import {renderIfElse} from '../../../utils/Utils';
import {AppLoadingIndicator, Page, TimeTable} from '../../components';

const TimeTablePage = () => {
  const isFocused = useIsFocused();
  const isLandscape = useIsLandscape();
  const {loading, value: timeTable} = useAsync(() => getMyTimetable(), [
    isFocused,
  ]);
  //console.log('timeTable>>>>', timeTable);
  const handleOpenLink = async (url) => {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      alert(`Don't know how to open this URL: ${url}`);
    }
  };

  const [, handleDownload] = useAsyncFn(async () => {
    try {
      const link = await getDownloadTimeTable();
      handleOpenLink(link);
    } catch (error) {
      console.log(
        '🚀 ~ file: index.jsx ~ line 53 ~ const[,handleDownload]=useAsyncFn ~ error',
        error,
      );
      alert(String(error));
    }
  }, []);

  const DownloadTimetable = () => (
    <TouchableOpacity onPress={() => handleDownload()}>
      <Icon style={styles.headerIcon} fill="white" name="download-outline" />
      <Text style={styles.downloadText}>Download</Text>
    </TouchableOpacity>
  );

  return (
    <Page
      header={{
        title: 'Timetable',
        showDrawerAction: true,
        accessoryRight: DownloadTimetable,
      }}
      scrollViewStyle={[
        isLandscape
          ? {paddingHorizontal: 8, paddingTop: 8}
          : {paddingHorizontal: 20},
      ]}>
      {loading ? (
        <AppLoadingIndicator />
      ) : (
        renderIfElse(
          timeTable?.length,
          <TimeTable
            useTimeTablePageStyle={isLandscape}
            hideTitle
            data={timeTable}
            containerStyle={styles.timeTable}
          />,
          <>
            <Text style={styles.noClassText}>
              {
                "No information available because you didn't subscribe for this month."
              }
            </Text>
            <Text status="danger" style={styles.noClassText2}>
              {
                "Note :- If you have purchased courses for next month, the 'Timetable' will be visible from the beginning of next month."
              }
            </Text>
          </>,
        )
      )}
    </Page>
  );
};

const styles = StyleSheet.create({
  timeTable: {
    paddingHorizontal: 0,
  },
  noClassText: {
    textAlign: 'center',
    marginTop: px(40),
    fontSize: px(18),
    fontWeight: '600',
  },
  noClassText2: {
    marginTop: px(20),
    fontSize: px(16),
    paddingHorizontal: px(36),
  },
  downloadText: {
    color: '#fff',
    fontSize: px(11),
  },
  headerIcon: {
    width: px(35),
    height: px(35),
    marginLeft: px(10),
  },
});

export default TimeTablePage;
